<template>
  <main class="ws">

    <section class="hero">
      <video class="hero__video" src="/website/img/ad.webm" autoplay loop muted playsinline></video>
      <div class="hero__mask"></div>

      <div class="hero__inner">
        <p class="hero__tag">{{ $t("不管你在供应链的哪一端") }}</p>
        <h1 class="hero__title">{{ $t("中国货，卖全球") }}</h1>
        <p class="hero__lead">{{ $t("零代码开店 · 多语言商城 · 一键铺货 · 全球收付款") }}</p>
        <p class="hero__desc">{{ $t("建站、翻译、收款、发货、获客，中间这几件麻烦事我们全包了。") }}</p>

        <div class="entry">
          <router-link class="entry__card" to="/for-china-sellers">
            <img class="entry__mascot" src="/website/img/tao-hanfu.png" alt="">
            <span class="entry__eyebrow">{{ $t("如果你在中国") }}</span>
            <h2 class="entry__title">{{ $t("我在中国") }}<br>{{ $t("要把货卖出去") }}</h2>
            <p class="entry__desc">{{ $t("不用会建站、不用懂外语、不用自己发国际快递") }}</p>
            <span class="entry__link">{{ $t("免费开店") }} <i>→</i></span>
          </router-link>
          <router-link class="entry__card" to="/for-global-sellers">
            <img class="entry__mascot" src="/website/img/tao-eagle.png" alt="">
            <span class="entry__eyebrow">{{ $t("如果你在海外") }}</span>
            <h2 class="entry__title">{{ $t("我在海外") }}<br>{{ $t("要卖中国好货") }}</h2>
            <p class="entry__desc">{{ $t("直连中国供应链，一件代发、不用压货、不用懂中文") }}</p>
            <span class="entry__link">{{ $t("看看能卖什么") }} <i>→</i></span>
          </router-link>
        </div>
      </div>
    </section>

    <section class="sec sec--gray" id="audience">
      <div class="wrap">
        <div class="sec__head">
          <span class="pill">{{ $t("对号入座") }}</span>
          <h2 class="sec__title">{{ $t("你在哪一端？两条路都能走通") }}</h2>
          <p class="sec__sub">{{ $t("两端缺的东西正好相反：一头缺把货送出去，一头缺把货弄到手。") }}</p>
        </div>
        <div class="guide guide--center" style="margin:-22px auto 36px">
          <img class="guide__m" src="/website/img/tao-point.png" alt="">
          <div class="bubble">{{ $t("两条路都在下面，") }}<b>{{ $t("选你站在的那一端") }}</b>{{ $t("往下读就行。选错了也不打紧，开店后随时能改。") }}</div>
        </div>
        <div class="aud">
          <article class="aud__col">
            <div class="aud__head"><span class="dot dot--pink"></span><h3>{{ $t("中国卖家") }}</h3></div>
            <ul>
              <li>{{ $t("有工厂或货源，想跳过中间商直接卖给老外") }}</li>
              <li>{{ $t("在平台卖了很多年，怕一条规则下来店就没了") }}</li>
              <li>{{ $t("主要做国内生意，想有个自己的店，不再把利润分给平台") }}</li>
            </ul>
            <router-link class="aud__more" to="/for-china-sellers">{{ $t("看中国卖家怎么开始") }} <i>→</i></router-link>
          </article>
          <article class="aud__col">
            <div class="aud__head"><span class="dot dot--green"></span><h3>{{ $t("海外卖家") }}</h3></div>
            <ul>
              <li>{{ $t("在当地已经有客源，想加点中国货但不想先压一批库存") }}</li>
              <li>{{ $t("想创业，找不到靠谱的工厂，也不会做网站") }}</li>
              <li>{{ $t("已经在做代购或微商，想把手上这些客户搬到一个正式的网站") }}</li>
            </ul>
            <router-link class="aud__more" to="/for-global-sellers">{{ $t("看海外卖家怎么开始") }} <i>→</i></router-link>
          </article>
        </div>
      </div>
    </section>

    <section class="sec" id="chain">
      <div class="wrap">
        <div class="sec__head">
          <span class="pill">{{ $t("全链路闭环") }}</span>
          <h2 class="sec__title">{{ $t("从工厂到客户手上") }}<br>{{ $t("中间这几件麻烦事，我们全包") }}</h2>
          <p class="sec__sub">{{ $t("不用再对接七八个系统，一个后台从头管到尾。") }}</p>
        </div>
        <div class="chain">
          <div class="chain__step">
            <img class="chain__icon" src="/website/img/FullChain-1@2x.png" alt="">
            <h4>{{ $t("快速建站") }}</h4>
            <p>{{ $t("10 分钟，零代码") }}<br>{{ $t("拥有专业品牌独立站") }}</p>
          </div>
          <img class="chain__arrow" src="/website/img/FullChain-arrow@2x.png" alt="">
          <div class="chain__step">
            <img class="chain__icon" src="/website/img/FullChain-2@2x.png" alt="">
            <h4>{{ $t("海量铺货") }}</h4>
            <p>{{ $t("1688 / 淘宝一键采集") }}<br>{{ $t("AI 翻译，批量上架") }}</p>
          </div>
          <img class="chain__arrow" src="/website/img/FullChain-arrow@2x.png" alt="">
          <div class="chain__step">
            <img class="chain__icon" src="/website/img/FullChain-3@2x.png" alt="">
            <h4>{{ $t("便捷收款") }}</h4>
            <p>{{ $t("支持全球主流支付") }}<br>{{ $t("资金安全直达") }}</p>
          </div>
          <img class="chain__arrow" src="/website/img/FullChain-arrow@2x.png" alt="">
          <div class="chain__step">
            <img class="chain__icon" src="/website/img/FullChain-4@2x.png" alt="">
            <h4>{{ $t("智能物流") }}</h4>
            <p>{{ $t("多仓发货，合箱出库") }}<br>{{ $t("实时跟踪，全球送达") }}</p>
          </div>
          <img class="chain__arrow" src="/website/img/FullChain-arrow@2x.png" alt="">
          <div class="chain__step">
            <img class="chain__icon" src="/website/img/FullChain-5@2x.png" alt="">
            <h4>{{ $t("持续运营") }}</h4>
            <p>{{ $t("数据分析，SEO 优化") }}<br>{{ $t("会员管理，长期复购") }}</p>
          </div>
        </div>
      </div>
    </section>

    <section class="sec sec--gray" id="features">
      <div class="wrap">
        <div class="sec__head">
          <span class="pill">{{ $t("平台特色") }}</span>
          <h2 class="sec__title">{{ $t("别的工具卖你一个网站") }}<br>{{ $t("我们给你一整个团队") }}</h2>
          <p class="sec__sub">{{ $t("建站只是起点。真正难的是三件事：") }}<b>{{ $t("没人干活、没人看见、货发不出去。") }}</b></p>
        </div>

        <div class="feat">
          <article class="feat__card">
            <div class="feat__top">
              <span class="feat__idx"><span class="dot dot--pink"></span>01</span>
              <span class="feat__badge">{{ $t("18 位员工") }}</span>
            </div>
            <h3>{{ $t("AI 员工") }}</h3>
            <p class="feat__kicker">{{ $t("你睡觉的时候，有人还在改标题、回差评、盯物流") }}</p>
            <ul class="feat__list">
              <li>{{ $t("每天巡检全店：缺图、缺描述、踩违规词，直接改掉") }}</li>
              <li>{{ $t("按成本、运费和佣金算真实毛利，不靠感觉定价") }}</li>
              <li>{{ $t("差评回复、社媒文案、客服话术、对账报告，点一下出稿") }}</li>
            </ul>
            <router-link class="feat__more" to="/ai-staff">{{ $t("看看这 18 位员工都干什么") }} <i>→</i></router-link>
          </article>

          <article class="feat__card">
            <div class="feat__top">
              <span class="feat__idx"><span class="dot dot--pink"></span>02</span>
              <span class="feat__badge">{{ $t("5 大渠道") }}</span>
            </div>
            <h3>{{ $t("AI 营销") }}</h3>
            <p class="feat__kicker">{{ $t("店建好了没人来 —— 这比建站难十倍") }}</p>
            <ul class="feat__list">
              <li>{{ $t("先诊断再开方：标题还是中文，就先修标题，不急着发内容") }}</li>
              <li>{{ $t("30 天方案拆成每天 2–3 件事，做完打勾") }}</li>
              <li>{{ $t("Google、Meta、TikTok、Snapchat、Microsoft 一站接入，像素有没有生效能自己验") }}</li>
            </ul>
            <a class="feat__more" href="#growth">{{ $t("看 30 天推广方案长什么样") }} <i>→</i></a>
          </article>

          <article class="feat__card">
            <div class="feat__top">
              <span class="feat__idx"><span class="dot dot--green"></span>03</span>
              <span class="feat__badge">{{ $t("零门槛") }}</span>
            </div>
            <h3>BuyLink</h3>
            <p class="feat__kicker">{{ $t("今天就能把淘宝、1688 的货，挂到自己站上卖") }}</p>
            <ul class="feat__list">
              <li>{{ $t("一条链接变一个商品页，图、价、规格自动填") }}</li>
              <li>{{ $t("买家点「代购下单」跳代购平台，商品链接已经填好") }}</li>
              <li>{{ $t("你只发国内快递，跨境支付和国际物流都不用碰") }}</li>
            </ul>
            <router-link class="feat__more" to="/feature#buylink">{{ $t("看懂这个模式") }} <i>→</i></router-link>
          </article>

          <article class="feat__card">
            <div class="feat__top">
              <span class="feat__idx"><span class="dot" style="background:#6355FF"></span>04</span>
              <span class="feat__badge">{{ $t("全链路") }}</span>
            </div>
            <h3>{{ $t("代购模式") }}</h3>
            <p class="feat__kicker">{{ $t("生意做大了，整条链路攥在自己手里") }}</p>
            <ul class="feat__list">
              <li>{{ $t("售价里含代购服务费，按比例或按固定金额收") }}</li>
              <li>{{ $t("入库称重、多个包裹合箱出库，比单件直发省") }}</li>
              <li>{{ $t("燕文、4PX 自动取号出单，轨迹自动回填给买家") }}</li>
            </ul>
            <router-link class="feat__more" to="/feature#buylink">{{ $t("对比它和 BuyLink 的区别") }} <i>→</i></router-link>
          </article>
        </div>

        <p class="feat__foot">{{ $t("这四件事，建站工具一件都做不了 —— 因为它们需要") }}<b>{{ $t("货源、仓库、承运商和真实数据，") }}</b>{{ $t("不是几段代码。") }}</p>
      </div>
    </section>

    <section class="sec" id="growth">
      <div class="wrap">
        <div class="sec__head">
          <span class="pill">{{ $t("AI 营销 · 获客") }}</span>
          <h2 class="sec__title">{{ $t("流量不是等来的，是一步一步算出来的") }}</h2>
          <p class="sec__sub">{{ $t("四步，每一步都能看到做完之后的变化。") }}</p>
        </div>

        <div class="steps steps--grid">
          <div class="steps__item">
            <div class="steps__top">
              <span class="steps__ico"><svg class="ico"><use href="#i-chart"/></svg></span>
              <span class="steps__no">{{ $t("第一步") }}</span>
            </div>
            <h4>{{ $t("先说真话") }}</h4>
            <p>{{ $t("商品标题还是中文？站是日语站、描述只有 1/65？先修地基，不急着发内容。") }}</p>
          </div>
          <div class="steps__item">
            <div class="steps__top">
              <span class="steps__ico"><svg class="ico"><use href="#i-route"/></svg></span>
              <span class="steps__no">{{ $t("第二步") }}</span>
            </div>
            <h4>{{ $t("30 天方案") }}</h4>
            <p>{{ $t("按你的品类、市场、库存，拆成每天 2–3 件能做完的小事。") }}</p>
          </div>
          <div class="steps__item">
            <div class="steps__top">
              <span class="steps__ico"><svg class="ico"><use href="#i-bolt"/></svg></span>
              <span class="steps__no">{{ $t("第三步") }}</span>
            </div>
            <h4>{{ $t("AI 出稿") }}</h4>
            <p>{{ $t("社媒短文、短视频脚本、营销邮件、活动方案，点一下就有。") }}</p>
          </div>
          <div class="steps__item">
            <div class="steps__top">
              <span class="steps__ico"><svg class="ico"><use href="#i-star"/></svg></span>
              <span class="steps__no">{{ $t("第四步") }}</span>
            </div>
            <h4>{{ $t("投放追效果") }}</h4>
            <p>{{ $t("五渠道接入，商品 feed 自动生成，像素没生效能自己查出来。") }}</p>
          </div>
        </div>

        <div class="mcp">
          <p><b>{{ $t("你的 AI 助手可以直接读你的店") }}</b><span>{{ $t("豆包 · ChatGPT · Claude 接上就能取商品、取方案、存稿件，不用把账号密码交给任何插件") }}</span></p>
          <router-link :to="{ path: '/ai-staff', hash: '#mcp' }">{{ $t("看怎么接") }} <i>→</i></router-link>
        </div>

        <div class="pandy">
          <img class="pandy__m" src="/website/img/panda.png" alt="">
          <div>
            <p class="pandy__t">{{ $t("这四步不用一次做完") }}</p>
            <p class="pandy__b">{{ $t("大部分人卡在第一步：连自己店里有多少条商品描述还是中文都不知道。先把这一步做完，后面三步才有意义。") }}<b>{{ $t("想省事就让 AI 先扫一遍，") }}</b>{{ $t("它会把该改的地方列出来。") }}</p>
          </div>
        </div>
      </div>
    </section>

    <section class="stats" id="stats">
      <div class="wrap">
        <h2 class="stats__title">{{ $t("能拿产品事实说清楚的，就不吹数字") }}</h2>
        <div class="stats__grid">
          <div>
            <div class="stats__ico"><svg class="ico"><use href="#i-globe"/></svg></div>
            <div class="stats__num">20</div>
            <div class="stats__label">{{ $t("种店铺语言") }}</div>
          </div>
          <div>
            <div class="stats__ico"><svg class="ico"><use href="#i-life"/></svg></div>
            <div class="stats__num">18</div>
            <div class="stats__label">{{ $t("位 AI 员工") }}</div>
          </div>
          <div>
            <div class="stats__ico"><svg class="ico"><use href="#i-chart"/></svg></div>
            <div class="stats__num">5</div>
            <div class="stats__label">{{ $t("大投放渠道") }}</div>
          </div>
          <div>
            <div class="stats__ico"><svg class="ico"><use href="#i-wallet"/></svg></div>
            <div class="stats__num">3–6%</div>
            <div class="stats__label">{{ $t("交易佣金阶梯") }}</div>
          </div>
        </div>
        <p class="stats__note">{{ $t("全部为你现在就能打开后台看到的数字，不是宣传口径。") }}</p>
      </div>
    </section>

    <section class="cta">
      <div class="wrap">
        <h2>{{ $t("准备好把这门生意做起来了吗") }}</h2>
        <p>{{ $t("零代码 · 订阅制 · 10 分钟拥有自己的品牌独立站") }}</p>
        <router-link class="cta__btn" to="/sign-up">{{ $t("立即免费开通") }}</router-link>
        <p class="cta__note">{{ $t("不需要信用卡 · 随时可以关掉") }}</p>
      </div>
    </section>

  </main>
</template>

<script>
export default {
  name: 'WebsiteHome',
}
</script>
